import React, { FC } from 'react';
import { NodeViewWrapper, NodeViewContent, ReactNodeViewProps } from '@tiptap/react';
import {
  FaInfoCircle,
  FaExclamationTriangle,
  FaLightbulb,
  FaStickyNote,
} from 'react-icons/fa';

// Cast icons to components with a className prop
type IconComponent = React.ComponentType<{ className?: string }>;

const StickyNoteIcon = FaStickyNote as IconComponent;
const WarningIcon = FaExclamationTriangle as IconComponent;
const InfoIcon = FaInfoCircle as IconComponent;
const TipIcon = FaLightbulb as IconComponent;

const AdmonitionComponent: FC<ReactNodeViewProps> = ({ node }) => {
  const { type } = node.attrs;

  let title = '';
  let Icon: IconComponent = StickyNoteIcon;
  let borderColorClass = '';
  let bgColorClass = '';
  let textColorClass = '';

  switch (type) {
    case 'note':
      title = 'Note';
      Icon = StickyNoteIcon;
      borderColorClass = 'border-blue-400';
      bgColorClass = 'bg-blue-50';
      textColorClass = 'text-blue-700';
      break;
    case 'warning':
      title = 'Warning';
      Icon = WarningIcon;
      borderColorClass = 'border-yellow-400';
      bgColorClass = 'bg-yellow-50';
      textColorClass = 'text-yellow-700';
      break;
    case 'info':
      title = 'Info';
      Icon = InfoIcon;
      borderColorClass = 'border-purple-400';
      bgColorClass = 'bg-purple-50';
      textColorClass = 'text-purple-700';
      break;
    case 'tip':
      title = 'Tip';
      Icon = TipIcon;
      borderColorClass = 'border-green-400';
      bgColorClass = 'bg-green-50';
      textColorClass = 'text-green-700';
      break;
    default:
      title = 'Admonition';
      Icon = StickyNoteIcon;
      borderColorClass = 'border-gray-400';
      bgColorClass = 'bg-gray-50';
      textColorClass = 'text-gray-700';
  }

  return (
    <NodeViewWrapper
      className={`admonition my-4 p-4 rounded-md border-l-4 ${borderColorClass} ${bgColorClass}`}
    >
      <div className={`admonition-title flex items-center font-bold mb-2 ${textColorClass}`}>
        <Icon className="mr-2" />
        {title}
      </div>
      <NodeViewContent className="admonition-content text-gray-800" />
    </NodeViewWrapper>
  );
};

export default AdmonitionComponent;
